import { AccessContent } from "../components/AccessContent";
import { ContactSupport } from "../components/ContactSupport";
import { Purchases } from "../components/Purchases";
import { COPILOT_ACTIONS } from "../constants/actions";

export const COPILOT_ACTION_RENDERERS = {
	[COPILOT_ACTIONS.REDEEM_ACCESS_CODE]: {
		component: AccessContent,
		loadingMessage: "Verifying your access code...",
	},
	[COPILOT_ACTIONS.GET_PURCHASES]: {
		component: Purchases,
		loadingMessage: "Getting your purchases...",
	},
	[COPILOT_ACTIONS.CONTACT_SUPPORT]: {
		component: ContactSupport,
		loadingMessage: "Generating your support email template...",
	},
};
